import React from 'react'

import { CardActions, Grid, TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import Button from '../../../../../UI/Button/Button'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'
import { KeyboardDatePicker } from '@material-ui/pickers'
import { validateAppraisalData } from '../../../../../../helpers/appraisal'

const AppraisalActionControls = ({
  translate,
  formInputChanged,
  form,
  submitted,
  cancelled,
  stageList,
  savedList,
  loading
}) => {
  let selected = null
  let stageOptions = stageList.map(item => {
    if (+form?.stage_id === +item.stage_id) {
      selected = {
        key: +item.stage_id,
        value: +item.stage_id,
        label: item.status_name,
        code: item.status_code
      }
    }
    return {
      key: +item.stage_id,
      value: +item.stage_id,
      label: item.status_name,
      code: item.status_code
    }
  })

  const structureSaved = savedList.includes(form.result_structure_id)
  let shouldValidateEndDate = false

  if (structureSaved) {
    stageOptions = []
    selected = null
  }

  let endDateInput = null
  if (selected?.code === 'CLS') {
    endDateInput = (
      <Grid item xs md={4} lg={3}>
        <KeyboardDatePicker
          inputVariant={'outlined'}
          inputProps={{ style: { padding: '10.5px 14px' } }}
          variant={'dialog'}
          format='YYYY MM DD'
          value={form.end_date}
          onChange={e => formInputChanged({ ...form, end_date: e?.format('YYYY-MM-DD') })}
        />
      </Grid>
    )

    shouldValidateEndDate = true
  }

  let submitButtonDisabled =
    structureSaved || loading || validateAppraisalData(form, shouldValidateEndDate)

  return (
    <CardActions style={{ padding: 0, paddingTop: 8 }}>
      <Grid container justify={'space-around'} spacing={1} style={{ alignItems: 'flex-start' }}>
        <Grid container item xs md={8} lg={9} spacing={1}>
          <Grid item xs md={5} lg={3}>
            <Autocomplete
              value={selected}
              size={'small'}
              onChange={(e, value) =>
                formInputChanged({ ...form, stage_id: +value?.value || null })
              }
              options={stageOptions}
              getOptionLabel={option => option.label || ''}
              renderInput={params => (
                <TextField {...params} fullWidth label={translate('action')} variant={'outlined'} />
              )}
            />
          </Grid>
          {endDateInput}
          <Grid item xs md lg>
            <TextField
              fullWidth
              multiline
              variant={'outlined'}
              label={translate('remark')}
              value={form.remark}
              size={'small'}
              onChange={e => formInputChanged({ ...form, remark: e.target.value })}
            />
          </Grid>
        </Grid>
        <Grid
          container
          item
          xs
          md={4}
          lg={3}
          justify={'space-evenly'}
          alignItems={'flex-start'}
          spacing={1}>
          <Grid item xs>
            <Button
              color={'primary'}
              clicked={submitted}
              disabled={submitButtonDisabled || !selected?.value}
              fullWidth>
              {translate('save')}
            </Button>
          </Grid>
          <Grid item xs>
            <Button color={'default'} clicked={cancelled} fullWidth>
              {translate('cancel')}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </CardActions>
  )
}

export default withTranslate(AppraisalActionControls)
